







import {Component} from 'vue-property-decorator'
import axios from 'axios'
import {apiV1AdminEventsPath} from '@/rails/routes'
import Event from '@/models/Event'
import EventForm from '@/components/admin/events/Form.vue'
import PageBase, {BreadCrumb} from '@/pages/page-base'

@Component({
  components: {
    EventForm
  }
})
export default class EventNew extends PageBase {
  event = new Event()

  mounted(): void {
    super.mounted()
  }

  async save(): Promise<void> {
    try {
      const res = await axios.post(apiV1AdminEventsPath(), {
        event: this.event.toParams()
      })
      this.event = new Event(res.data)
      this.$router.push(`/admin/events/${this.event.id}/edit`)
      this.showMessage('変更を保存しました。')
    } catch (e) {
      console.log(e)
    }
  }

  get breadcrumbs(): Array<BreadCrumb> {
    return [
      {
        text: 'イベント一覧',
        to: '/admin/events',
        exact: true
      },
      {
        text: 'イベント新規作成'
      }
    ]
  }
}
